const utils = require("frontend-controller/lib/utils");
module.exports = {
    config: {
        showColorBar: false,
        tabConfigNavKey: '',
        openTabsInMainNav: false,
        showEditByMySelf: false, // used for e.g., modal actions
        usage: null, // may be 'selection' if showEdit should be used as select. e.g., moving projectTerms to another project uses a target project selection
        isMultiSelect: true,
        parentEntityPreparationGranted: true,
    },

    model: {
        tabConfig: false,
        parentEntity: null,
        decisionOrigin: null,
    },

    methods: {
        prepare(){
            // prevent parentEntity from being stored within model if necessary. e.g., prevent data cascades in case of projects since they are at the very top in every use case.
            if(this.config.parentEntityPreparationGranted){
                this.model.parentEntity = this.getResourceRegisterContent('parentEntity') || {}
            }
            this.model.decisionOrigin = this.getResourceRegisterContent('decisionOrigin') || {}
            utils.refMerge(this.config, this.getResourceRegisterContent('controllerConfig') || {})
        },

        gatherTabConfig(){
            if(!this.model.tabConfig && this.config.tabConfigNavKey){
                this.furthest('base_tabStrip_tabStrip', undefined, mainNav => {
                    const tab = mainNav.getTabByNavKey(this.config.tabConfigNavKey)
                    if((tab || {}).resourceData){
                        const colors = tab.resourceData.colors || {}
                        this.model.tabConfig = {
                            activeBG: colors.activeSubTabBG,
                            colorBarColor: colors.activeBG || '#818181',
                            icon: tab.resourceData.aliasIcon,
                            iconColor: colors.activeBar,
                        }
                    }
                })
            }
        },

        initColorBar(){
            if(this.config.showColorBar && (this.model.tabConfig || {}).colorBarColor){
                const $container = this.$.find('section.left')
                const $colorBar = $container.find('.templates_core_controller_colorBar')
                if($container.length > 0 && $colorBar.length < 1){
                    $container.prepend(
                        this.include(
                            './colorBar',
                            {
                                model: {
                                    color: this.model.tabConfig.colorBarColor
                                }
                            }
                        )
                    );
                }
            }
        },

        showInsert(buttonContext, buttonMode, extensionData, resourceRegister){
            // called via utils.performButtonAction
            if(arguments.length > 4){
                buttonContext = buttonMode
                buttonMode = undefined
                extensionData = undefined
                resourceRegister = undefined
            }

            const baseActionKey = `showInsert_${buttonContext}`
            const actionKey = `${baseActionKey}_inEffect`
            const parentEntity = this.model.parentEntity || {}
            extensionData = extensionData || {}
            resourceRegister = resourceRegister || {}

            // prevent resourceID usage via resourceRegisterKey in case of insertions.
            resourceRegister = utils.simpleMerge({
                parentEntityForProperties: {
                    resourceID: null
                }
            }, resourceRegister)

            // add parents primaryKey as foreign key if necessary
            if(parentEntity.primaryKey && parentEntity.entityID && buttonMode !== 'preventParentEntityForeignKey'){
                resourceRegister = utils.simpleMerge(resourceRegister, {
                    dirtyAttributesForProperties: {
                        [parentEntity.primaryKey]: parentEntity.entityID,
                    }
                })
            }

            return this.performAndStoreAction(
                actionKey,
                this.prepareAction(baseActionKey, undefined, resourceRegister, extensionData),
                true
            )
        },

        showEdit(context, entityID, entityData, resourceRegister, extensionData, forceShowEditBossComponent){
            if(this.config.usage === 'ignore') {
                return
            }

            resourceRegister = resourceRegister || {}
            entityData = entityData || {}
            const entityAttributes = entityData.attributes || {}

            this.gatherTabConfig()

            resourceRegister.tabOptions = this.sanitizeTabOptionsByAttributes({
                icon: this.model.tabConfig.icon,
                colors: {
                    activeBG: this.model.tabConfig.activeBG,
                    icon: this.model.tabConfig.iconColor,
                },
                title: entityAttributes.title,
                titleSuffix: ` [${entityID}]`
            }, entityAttributes, entityID)
            resourceRegister.parentEntity = {
                entityID,
                entityData,
                primaryKey: entityData.primaryKey,
            }
            resourceRegister.parentEntityForProperties = {
                resourceID: entityID,
            }
            resourceRegister.parentEntityForTable = {
                baseFilters: {
                    [entityData.primaryKey]: entityID
                }
            }
            resourceRegister.parentEntityForStatus = {
                baseFilters: {
                    [entityData.primaryKey]: entityID
                }
            }
            resourceRegister.decisionOrigin = this.model.decisionOrigin

            let showEditBossComponent, showEditMethod = 'showEdit'
            if(forceShowEditBossComponent) {
                showEditBossComponent = forceShowEditBossComponent
            } else if(this.config.usage === 'selection') {
                showEditMethod = 'select'
                showEditBossComponent = this
            } else if(this.config.showEditByMySelf) {
                showEditMethod = 'performShowEdit'
                showEditBossComponent = this
            } else if(this.config.openTabsInMainNav){
                showEditBossComponent = getComponent('mainNav')
            } else {
                this.closest('templates_core_tabStrip_tabStrip', tabStrip => {
                    showEditBossComponent = tabStrip
                })
            }

            if(showEditBossComponent && utils.isFunction(showEditBossComponent[showEditMethod])){
                return showEditBossComponent[showEditMethod](context, entityID, resourceRegister, entityData, extensionData)
            } else {
                console.error('showEditBossComponent missing')
            }
        },

        performShowEdit(context, entityID, resourceRegister, entityData, extensionData){
            const baseActionKey = `showEdit_${context}`
            const actionKey = `${baseActionKey}_inEffect_${entityID}`

            if(this.actions[actionKey]){
                return this.performAction(actionKey)
            } else {
                return this.performAndStoreAction(
                    actionKey,
                    this.prepareAction(baseActionKey, entityID, resourceRegister, extensionData || {}),
                    false
                )
            }
        },

        showDuplicateOptions(context, entityID, entityData){
            const baseActionKey = `showDuplicateOptions_${context}`
            const actionKey = `${baseActionKey}_inEffect`

            this.model.showDuplicateOptions = {
                entityID,
                entityData,
                context,
            }

            return this.performAndStoreAction(
                actionKey,
                this.prepareAction(baseActionKey, undefined, undefined, {
                    source: {
                        load: {
                            componentData: {
                                config: {
                                    isDuplicationOptionsModal: true,
                                },
                            },
                        },
                    },
                }),
                true
            )
        },

        showExportOptions(context, mode){
            // called via utils.performButtonAction
            if(arguments.length > 4){
                context = mode
                mode = undefined
            }

            const baseActionKey = `showExportOptions_${context}`
            const actionKey = `${baseActionKey}_inEffect`

            this.model.showExportOptions = {
                context,
            }

            return this.performAndStoreAction(
                actionKey,
                this.prepareAction(baseActionKey, undefined, undefined, {
                    source: {
                        load: {
                            componentData: {
                                config: {
                                    isExportOptionsModal: true,
                                },
                            },
                        },
                    },
                }),
                true
            )
        },

        async duplicate(context, duplicateOptions){
            const {entityID} = (this.model.showDuplicateOptions || {})

            if(!entityID){
                return this.performMessage({
                    messageDisplay: {
                        message: `error:${context}.duplicate.missingEntityID`
                    }
                })
            }

            const actionContext = await this.performAction(
                this.prepareAction(`duplicate_${context}`, entityID, undefined, {
                    source: {
                        submit: {
                            data: {
                                resourceFilters: {
                                    duplicateOptions: {
                                        ...(duplicateOptions || {}),
                                        entityID,
                                    }
                                }
                            }
                        }
                    }
                })
            )

            const data = ((actionContext || {}).response || {}).data || {}
            const attributes = data.attributes || {}
            const newEntityID = attributes[data.primaryKey || 'id']

            if(!newEntityID){
                return this.performMessage({
                    messageDisplay: {
                        message: `error:${context}.duplicate.missingNewEntityID`
                    }
                })
            }

            return this.showEdit(context, newEntityID, data)
        },

        async export(context, exportOptions){

            const {
                from,
                to,
                status,
            } = (exportOptions || {})

            if(!from && !to){
                return this.performMessage({
                    messageDisplay: {
                        message: `error:${context}.export.missingAtLeastOneTimestamp`
                    }
                })
            }

            const resourceFilters = {
                from,
                to,
                status,
                offest: 0,
                limit: 500000,
            }

            const kw = {
                from:   from ?  utils.moment(from).format('W')  : '',
                to:     to ?    utils.moment(to).format('W')    : '',
            }

            const filename = `${storage.__(`${context}.export.filename`)}_${kw.from && kw.to && kw.from !== kw.to ? `KW${kw.from}-${kw.to}` : kw.from || kw.to ? `KW${kw.from || kw.to}` : ''}.xlsx`;
            const url = `/LTR/~/exports/${this.scope || 'routeTree'}/${context || 'trips'}/~/${filename}`

            // create form to download file
            const form 	= document.createElement('FORM')
            form.method = 'POST'
            form.action = url
            form.style = 'display: none;'
            form.target = '_blank' // Specify the name of the window(second parameter to window.open method.)
            const input = document.createElement('INPUT')
            input.name 	= 'exportParams'
            input.type 	= 'hidden'
            input.value = Buffer.from(JSON.stringify({
                resourceFilters,
            })).toString('base64')
            form.appendChild(input)
            document.body.appendChild(form)
            form.submit()
            form.remove()
        },

        select(context, entityID, resourceRegister, entityData){
            this.triggerClosest('onDecision', {
                decisionComponent: this,
                decisionType: 'submit',
                decisionOrigin: resourceRegister.decisionOrigin || {},
                decisionOptions: {
                    context,
                    entityID,
                    entityData,
                    resourceRegister,
                }
            });
        },

        delete(buttonContext, entityID, entityData){
            const baseActionKey = `delete_${buttonContext}`

            if(this.actions[baseActionKey] && !utils.isEmpty(entityID)){
                return this.performDecision(
                    'confirm',
                    {
                        component:  this,
                        title:      storage.__('hint.delete.really.' + buttonContext + '.title'),
                        message:    storage.__('hint.delete.really.' + buttonContext + '.message')
                    }
                ).then(context => {
                    if (context.decision.type === 'yes') {
                        return this.performAction(
                            this.prepareAction(baseActionKey, entityID)
                        ).then(context => {
                            // this is an additional call to prevent local client errors if heartbeat fails.
                            this.callHandler('postDeleteRecord', [
                                buttonContext,
                                entityID,
                                entityData
                            ]);
                            return context;
                        });
                    }

                    return utils.promise.reject();
                });
            }
        },

        sanitizeTabOptionsByAttributes(tabOptions, entityAttributes, entityID){
            return tabOptions
        },

        submit(){
            let response = utils.promise.resolve()
            this.find('base_form_form', form => {
                response = form.submit()
                return 'break'
            })
            return response
        },

        async handleError(context){
            context = context || {}
            const {
                // statusCode,
                errorCode,
                column,
            } = utils.extractBaseError(context.error) || {}
            const originalActionKey = context.action.originalActionKey

            const messageKey = `${this.config.tabConfigNavKey || 'all'}.${originalActionKey || 'all'}.${errorCode || 'all'}.${column || 'all'}`
            const fullMessageKey = `error:${messageKey}`
            if(messageKey === storage.__(fullMessageKey)) {
                context.errorUnhandled = true
            } else {
                await this.performMessage({
                    messageDisplay: {
                        message: fullMessageKey,
                    }
                })
            }

            return utils.promise.resolve(context)
        },
    },

    hooks: {
        attach: function($element, options){
            this.gatherTabConfig()

            if(options.refresh) {
                this.model.colorBarInitialized = false
                this.initColorBar()
            }

        },

        async onDecision($element, options){
            options.processing = {}

            let modal
            let modalContentComponent
            switch(options.decisionComponent.componentClass) {
                case 'base_modal_modal':
                case 'templates_core_modal_modal':
                    modal = options.decisionComponent
                    modalContentComponent = modal.actions.loadContent.source.load.component;
                    break;
            }

            switch(options.decisionType){
                case 'submit':
                case 'submitRefresh':
                    // duplicate options form
                    if(modalContentComponent.hasClass('base_form_form') && ((modal || {}).config || {}).isDuplicationOptionsModal){
                        const duplicateOptions = ((modalContentComponent.model.dirtyFields || {}).data || {}).attributes || {}
                        const {context} = this.model.showDuplicateOptions || {}
                        await modal.hide()
                        return this.duplicate(context, duplicateOptions)
                    }

                    // export options form
                    if(modalContentComponent.hasClass('base_form_form') && ((modal || {}).config || {}).isExportOptionsModal){
                        const exportOptions = ((modalContentComponent.model.dirtyFields || {}).data || {}).attributes || {}
                        const {context} = this.model.showExportOptions || {}
                        await modal.hide()
                        return this.export(context, exportOptions)
                    }

                    // insert form or propertiesController
                    if(utils.isFunction((modalContentComponent || {}).submit)){
                        options.processing.submit = await modalContentComponent.submit()
                        if(options.decisionType === 'submitRefresh'){
                            await modalContentComponent.refresh()
                        } else {
                            await modal.hide()
                        }
                    }
                    break;

                case 'cancel':
                    if(modal){
                        modal.hide()
                    }
                    break
            }
        },
    },

    handlers: [{
        name: 'onTabActivate',
        componentClass: 'templates_core_tabStrip_tab',
        handle: function(callerComponent){
            if(callerComponent.config.isMainTab){
                this.gatherTabConfig()
                this.initColorBar()
            }
        }
    }]
}
